import React from 'react';
import AttachmentPreviewSection from '../shared/AttachmentPreviewSection';
import { Attachment } from '../../../../../..';
import { DialogContentProps } from '../..';
import MobileAttachmentDetailsSection from './components/MobileAttachmentDetailsSection';

const MobileView = <T extends Attachment, >({ activeAttachment, handleClose, AttachmentDetails }: DialogContentProps<T>) => {
  return (
    <MobileAttachmentDetailsSection
      handleClose={handleClose}
      activeAttachment={activeAttachment}
      AttachmentDetails={AttachmentDetails}
    >
      <AttachmentPreviewSection attachment={activeAttachment} />
    </MobileAttachmentDetailsSection>
  );
};

export default MobileView;